import { ApiError, ConflictError, type Appointment } from '../api/client'
import { todayIso } from './dates'
import { clientName } from './names'

// canMarkNoShow: "Didn't come" is offered on a booked appointment (not a hold
// still waiting for its deposit) once it has started, or any time on its
// day — the same rule the API applies (409 appointment-not-started otherwise).
export function canMarkNoShow(
  a: Pick<Appointment, 'status' | 'awaiting_deposit' | 'starts_at' | 'date'>,
  now: Date = new Date(),
): boolean {
  if (a.status !== 'booked' || a.awaiting_deposit) return false
  const starts = new Date(a.starts_at).getTime()
  return (!Number.isNaN(starts) && starts <= now.getTime()) || a.date === todayIso(now)
}

// undoNoShowRefusal words why Undo on a no-show was refused, or null for an
// error that is not one of its known refusals. Only an appointment booked
// into the time after the no-show stops it (one booked over it "anyway"
// before does not), and the API names those, so the toast can too.
export function undoNoShowRefusal(err: unknown): string | null {
  if (err instanceof ConflictError) {
    const names = [...new Set(err.conflicts.map((c) => clientName(c.client)))]
    if (names.length === 1) return `Couldn’t undo: ${names[0]} was booked into that time since.`
    return 'Couldn’t undo: another appointment was booked into that time since.'
  }
  if (err instanceof ApiError && err.problem === 'appointment-state') return 'Couldn’t undo: a payment has moved since.'
  return null
}
